export default function HomepageSkeleton() {

    return (
        <div className={'animate-pulse'}>

            {/* Hero */}
            <section className={'bg-gray-200 h-75 lg:h-125 w-full'} />

            {/* Categories */}
            <section className={'max-w-7xl mx-auto px-2 py-6'}>
                <div className={'h-8 bg-gray-200 rounded w-48 mb-4'} />

                <div className={'grid grid-cols-2 lg:grid-cols-6 gap-3'}>
                    {[...Array(6)].map((_, i) => (
                        <div
                            key={i}
                            className={'bg-gray-200 rounded-xl aspect-square'}
                        />
                    ))}
                </div>
            </section>

            {/* Product slider */}
            <section className={'max-w-7xl mx-auto px-2 py-6'}>
                <div className={'h-8 bg-gray-200 rounded w-64 mb-4'} />

                <div className={'grid grid-cols-2 lg:grid-cols-5 gap-3'}>
                    {[...Array(5)].map((_, i) => (
                        <div
                            key={i}
                            className={'bg-gray-200 rounded-xl h-65'}
                        />
                    ))}
                </div>
            </section>

        </div>
    );
}